<template>
   <div id="book-container">

      <div style="display: flex; justify-content: space-between; align-items: center; ">
         <v-btn icon x-large class="pl-5" @click="next" :disabled="page_ix>=260">
            <v-icon x-large>
               arrow_back_ios
            </v-icon>
         </v-btn>

         <!--width:calc(100% - 130px); height: auto;-->

         <div style="display: flex; align-items: center">
            <div  v-if="!isLoaded"
                  style="position: fixed;" :style="spinner_style"
            >
               <v-progress-circular
                   indeterminate
                   size="100"
                   color="grey"

               />
            </div>
            <img :src="page_url"
                 style=" max-height: 1200px; height: calc(100vh - 50px)"
                 id="jp-book-img"
            >


         </div>


         <v-btn icon x-large class="pl-1" @click="prev" :disabled="page_ix<=1">
            <v-icon x-large>
               arrow_forward_ios
            </v-icon>
         </v-btn>
      </div>


      <!--page selector-->

      <div style="display: flex; justify-content: center">
         <div style="width: 100px">
            <v-select
                label="Page"
                v-model="page_ix"
                :items="pages"
            />
         </div>

      </div>


   </div>
</template>

<script>
export default {
   name: "book",
   data() {
      return {
         // page_url: null,
         page_ix: 0,
         isLoaded: false,

         img_width: 0,
      }

   },

   watch: {
      page_ix() {
         this.isLoaded = false;

         let el = document.getElementById('book-container');
         // console.log({el})
         if (el != null) {
            let width = el.offsetWidth;
            this.img_width = width;
         }
      },
   },


   computed: {
      page_url() {
         let ix = String(this.page_ix).padStart(4, '0');
         return `https://totalhealthfoundation.nyc3.digitaloceanspaces.com/jp/book/doctor-on-crutches/book_${ix}.jpg`
      },

      pages() {
         let ans = [];
         for (let i = 1; i <= 260; i++) {
            ans.push(i);
         }
         return ans;
      },

      spinner_style() {
         let ans = '';
         console.log('width', this.img_width);
         if (this.img_width && this.img_width > 0 ) {
            //50 for spinner, 50 for left arrow
            ans = `padding-left: ${this.img_width / 2 - 50 - 50}px`;
         }

         console.log('width', ans);
         return ans;

      }
   },


   methods: {
      next() {
         if (this.page_ix < 260) {
            this.page_ix += 1;
         }
      },
      prev() {
         if (this.page_ix > 1) {
            this.page_ix -= 1;
         }
      },

      load_image(event) {
         // console.log(event);
         this.isLoaded = true;


      }
   },

   mounted() {
      // window.addEventListener("load", this.load_image);

      let image = document.getElementById('jp-book-img');
      image.onload = this.load_image;

      // this.isLoaded = false;
      this.page_ix = 1;
   },

   beforeDestroy() {
      window.removeEventListener("load", this.load_image);
   }


}
</script>

<style scoped>

</style>